import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions, Response} from '@angular/http';

import {Accountbranch} from './accountbranch';

@Injectable()
export class AccountbranchService {

  constructor(private http: Http) {

  }

  getAll(page: number = 1, sort: string = '') {
    let currentfilter = JSON.parse(localStorage.getItem('filter'));
    if(!currentfilter) {
      currentfilter = {};
    }

    const params = new URLSearchParams();
    params.set('page',  page+'');
    params.set('sorts', sort);
    for (let key in currentfilter) {
      if(currentfilter[key]) {
        params.set('filter[' + key + ']', currentfilter[key])
      }
    }
    return this.http.get('branches?' + params.toString()).map((response: Response) => response.json());
  }

  getById(_id: string) {
    return this.http.get('branches/' + _id).map((response: Response) => response.json());
  }

  getAllbranches() {
    return this.http.get('branches/all').map((response: Response) => response.json());
  }

  getUserbranches() {
    return this.http.get('branches/userbranches').map((response: Response) => response.json());
  }

  getTrashedById(_id: string) {
    return this.http.get('branches/trashed/' + _id).map((response: Response) => response.json());
  }
  restoreTrashedById(_id: string) {
    return this.http.put('branches/trashed/' + _id,{}).map((response: Response) => response.json());
  }

  create(accountbranch: Accountbranch) {
    return this.http.post('branches', accountbranch).map((response: Response) => response.json());
  }

  update(accountbranch: Accountbranch) {
    return this.http.put('branches/' + accountbranch.id, accountbranch).map((response: Response) => response.json());
  }

  delete(_id: string) {
    return this.http.delete('branches/' + _id);
  }
}



// WEBPACK FOOTER //
// ./src/app/views/fin/accountbranches/accountbranch.service.ts